<div
  class="multi-select-dropdown"
  [class.disabled]="isDisabled()"
  [placement]="
    relativelyPositioned() ? 'bottom-start' : ['bottom-start', 'bottom-end', 'top-start', 'top-end']
  "
  ngbDropdown
>
  <div ngbDropdownAnchor>
    <input
      class="form-control"
      type="text"
      [placeholder]="dynamicPlaceholder()"
      [readonly]="disableSearch()"
      [formControl]="searchControl"
      [ngClass]="{
        'bordered-radius-bottom colored-border': dropdown()?.isOpen(),
      }"
      (focus)="dropdown().open()"
    />
    @if (!isLoadingMenuItems()) {
      @if (!hideRemoveAllIcon() && formGroupSelectedCount() > 0) {
        <rs-web-icon
          (click)="clearAndApply()"
          class="icon icon-remove"
          [icon]="ImmomioIconName.Close"
          [size]="12"
        ></rs-web-icon>
      }

      <rs-web-icon
        class="icon icon-dropdown"
        (click)="dropdown()?.toggle()"
        [class.rotate]="dropdown()?.isOpen()"
        [icon]="ImmomioIconName.ChevronDown"
        [size]="12"
      ></rs-web-icon>
    } @else {
      <div class="loading-area-input">
        <rs-web-loader></rs-web-loader>
      </div>
    }
  </div>

  <div class="dropdown-menu" [class.relative-positioned]="relativelyPositioned()" ngbDropdownMenu>
    <div class="dropdown__items" [class.d-none]="!dropdown()?.isOpen()">
      @if (sortedItems()?.length) {
        <rs-web-infinite-scroll (scrolled)="onScroll()">
          @for (item of sortedItems(); track item[itemValueKey()]; let i = $index) {
            <div (click)="checkbox.click()" class="dropdown__item" [formGroup]="formRecord">
              <ng-template
                [ngTemplateOutlet]="templateRef()"
                [ngTemplateOutletContext]="{ $implicit: item }"
              ></ng-template>
              <input
                #checkbox
                class="form-check-input"
                type="checkbox"
                (click)="$event.stopPropagation()"
                [formControl]="formRecord.get(item[itemValueKey()]) | formControlPipe"
              />
            </div>
          }
        </rs-web-infinite-scroll>
      } @else {
        @if (searchCharactersLimit() > 0 && searchControl.value.length < searchCharactersLimit()) {
          <div class="no-items-content">
            <span
              >{{
                'single_select_dropdown.minimum_character_l'
                  | translate: { customValue: searchCharactersLimit() }
              }}
            </span>
          </div>
        } @else {
          <div class="no-items-content">
            <ng-content select="[no-items-content]"></ng-content>
          </div>
        }
      }
    </div>

    @if (sortedItems()?.length) {
      <div class="dropdown__actions">
        <button class="btn" (click)="clear()">
          {{ 'multiselect.reset_l' | translate }}
        </button>
        <button class="btn" (click)="apply()">
          {{ 'multiselect.accept_l' | translate }}
        </button>
      </div>
    }
  </div>
</div>
